export class VenueBookingQueryRequest {
  body: VenueBookingQueryBody = new VenueBookingQueryBody();
}

export class VenueBookingQueryBody {
  ProcessName: string = 'DC Community Portal SR Process Wrapper WF';
  DCMethod: string = 'QUERY';
  DCLanguage: string = 'ENU';
  DCLoginName: string = '';
  DCIncomingHierarchy: VenueBookingQueryIncomingHierarchy = new VenueBookingQueryIncomingHierarchy();
}

export class VenueBookingQueryIncomingHierarchy {
  MessageId: string = '';
  IntObjectName: string = 'DC Community Portal SR IO';
  MessageType: string = 'Integration Object';
  IntObjectFormat: string = 'Siebel Hierarchical';
  'ListOfDC Community Portal SR IO': VenueBookingQueryList = new VenueBookingQueryList();
}

export class VenueBookingQueryList {
  'DC Community Portal SR': VenueBookingQueryServiceRequest = new VenueBookingQueryServiceRequest();
}

export class VenueBookingQueryServiceRequest {
  'SR Number': string = '';
  'SR Type': string = 'Venue Booking';
  'Sub Type': string = 'Venue Booking';
  CSN: string = '';
}
